import { Alert, Button, Divider, FormControl, FormLabel, Grid, IconButton, LinearProgress, List, ListItem, ListItemButton, ListItemText, Snackbar, Stack, TextField, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import Api from "../api/Api";
import { UserContext } from "../context/UserContextProvider";
import { useCookies } from "react-cookie";
import { NotInterested, Payment } from "@mui/icons-material";

const SocialShareAdminPage = () => {
    const { user } = useContext(UserContext);
    const [pendingSocialImpressions, setPendingSocialItems] = useState([]);
    const [isValidToken, setValidToken] = useState(true);
    const [newToken, setNewToken] = useState('');
    const [alertState, setAlertState] = useState({ show: false, success: true, message: '' });
    const [active, setActive] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [token, setToken] = useState('')

    useEffect(() => {
        setToken(localStorage.getItem('token'));
    }, [])

    useEffect(() => {
        if (!user.idem_guid || !token) {
            return;
        }

        const fetch = async () => {
            setActive(true);
            setLoading(true);
            setPendingSocialItems(await Api.getPendingSocialImpressions(token, user.idem_guid));
            setLoading(false);
        }
        fetch();
    }, [user.idem_guid, token]);

    const validateAndSetToken = async () => {
        try {
            const response = await Api.validateToken(newToken, user.idem_guid);
            if (response.valid) {
                setToken(newToken);
                localStorage.setItem('token', newToken);
                setAlertState({ show: true, success: true, message: `The token was successfully validated.` })
            } else {
                setAlertState({ show: true, success: false, message: `The token is invalid.` })
                setValidToken(false);
            }
        } catch (e) {
            setAlertState({ show: true, success: false, message: `Internal server error. Could not process the request.` })
        }
    }

    const validateImpression = async (/** @type {{ campaign: string; }} */ item, /** @type {boolean} */ isValid) => {
        try {
            await Api.validateSocialShareCampaign(item.campaign, isValid, token, user.idem_guid);
            setPendingSocialItems(pendingSocialImpressions.filter(mItem => mItem !== item));
        } catch (e) {
            setAlertState({ show: true, success: false, message: `Internal server error. Could not process the request.` });
            return;
        }
    }

    const handleCloseFormUpdateAlert = (/** @type {any} */ _event, /** @type {string} */ reason) => {
        if (reason === 'clickaway') {
            return
        }

        setAlertState({ show: false, success: true, message: '' })
    }

    if (!user) {
        return <LinearProgress />;
    }

    return <Grid container spacing={2}>
        <Grid item xs={12} justifyContent={'center'} display={'flex'}>
            <Typography variant='h6' sx={{ color: 'white' }}>
                Social Share Admin Page
            </Typography>
        </Grid>
        {!token && <>
            <Grid item xs={12}>
                <FormControl fullWidth error={!isValidToken}>
                    <FormLabel sx={{ color: 'white' }} >Token</FormLabel>
                    <TextField value={newToken} onChange={e => {
                        setValidToken(e.target.value !== '');
                        setNewToken(e.target.value);
                    }} error={!isValidToken} />
                </FormControl>
            </Grid>
            <Grid item xs={12} display={'flex'} justifyContent={'center'}>
                <FormControl error={!isValidToken}>
                    <Button variant={'contained'} onClick={validateAndSetToken} disabled={!isValidToken || newToken.length === 0}>Set Token</Button>
                </FormControl>
            </Grid>
        </>}
        {active && isLoading && <Grid item xs={12}>
            <LinearProgress />
        </Grid>}
        {active && pendingSocialImpressions.length > 0 && <List sx={{ mt: 4, width: '100%', borderColor: 'rgba(255, 255, 255, 0.12)', borderWidth: '1px', borderStyle: 'solid' }}>
            {pendingSocialImpressions.map((item, idx) => <ListItem key={idx} disablePadding divider={idx < pendingSocialImpressions.length - 1 ? true : false} secondaryAction={<Stack direction={'row'}>
                <IconButton color='success' onClick={() => validateImpression(item, true)}><Payment /></IconButton>
                <IconButton color='error' onClick={() => validateImpression(item, false)}><NotInterested /></IconButton>
            </Stack>}>
                <ListItemButton href={item.target} target="_blank" sx={{ paddingRight: '96px!important' }}>
                    <ListItemText primary={item.target} sx={{ color: 'white', ['& .MuiListItemText-primary']: { overflow: 'hidden', textOverflow: 'ellipsis' } }} />
                </ListItemButton>
            </ListItem>)}
        </List>}
        {active && pendingSocialImpressions.length === 0 && !isLoading && <Grid item xs={12}>
            <Typography color={'white'}>There is no pending request to be processed.</Typography>
        </Grid>}
        {alertState.show && (
            <Snackbar
                open={alertState.show}
                autoHideDuration={4000}
                onClose={handleCloseFormUpdateAlert}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            >
                <Alert
                    onClose={handleCloseFormUpdateAlert}
                    severity={alertState.success ? 'success' : 'error'}
                    variant={'filled'}
                    elevation={6}
                    sx={{ width: '100%' }}
                >
                    {alertState.message}
                </Alert>
            </Snackbar>
        )}
    </Grid>
}

export default SocialShareAdminPage;